import { calculationTypes } from "./types";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case calculationTypes.GETCAMPAIGNS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case calculationTypes.GETCAMPAIGNS_ERROR:
      return {
        ...state,
        ...action.error,
      };
    case calculationTypes.TOGGLE_CAMPAIGN_MODAL:
      return {
        ...state,
        ...action.payload,
      };
    case calculationTypes.GETPAYMENTPLAN_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case calculationTypes.GETPAYMENTPLAN_ERROR:
      return {
        ...state,
        ...action.error,
      };
    case calculationTypes.TOGGLE_ADDRESS_MODAL:
      return {
        ...state,
        ...action.payload,
      };
    case calculationTypes.SAVEADDRESS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case calculationTypes.SAVE_PERSONEL_INFO_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case calculationTypes.SET_SELECTED_CAMPAIGN:
      return {
        ...state,
        ...action.payload,
      };
    case calculationTypes.CUSTOMER_HAS_ADDRESS:
      return {
        ...state,
        ...action.payload,
      };
    case calculationTypes.CUSTOMER_HAS_PERSONEL_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case calculationTypes.SAVE_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case calculationTypes.SAVE_MEMBERSHIP_ERROR:
      return {
        ...state,
        ...action.error,
      };
    default:
      return state;
  }
};
